const getters = {
    postData(state) {
        return {
            card_id: state.card,
            type: state.type,
            name: state.name,
            published: state.published,
            order: state.order,
            level: state.level,

            options: {
                audio: state.options.audio,
                help_text: state.options.helpText,
                help_title: state.options.helpTitle,
                uploaderInstructionText: state.options.uploaderInstructionText,

                fields_in_group: state.options.fieldsInGroup,
                group: state.options.group,
                groupNumbered: state.options.groupNumbered,
                groupInline: state.options.groupInline,

                static_text: state.options.staticText,
                upsell: state.options.upsell,
                custom_color_access_level: state.options.customColorAccessLevel,
                custom_color_upsell: state.options.customColorUpsell,
                custom_font_access_level: state.options.customFontAccessLevel,
                custom_font_upsell: state.options.customFontUpsell,

                preview_hero_headline: state.options.preview.heroHeadline,
                preview_hero_subhead: state.options.preview.heroSubhead,
                preview_hero_button_text: state.options.preview.heroButtonText,
                preview_banner_1: state.options.preview.banner1,
                preview_banner_2: state.options.preview.banner2,
                preview_banner_3: state.options.preview.banner3,
                preview_body_headline: state.options.preview.bodyHeadline,
                preview_body_copy: state.options.preview.bodyCopy,
                preview_body_button_text: state.options.preview.bodyButtonText,
                preview_hero_image: state.options.preview.heroImage,
                preview_headshot: state.options.preview.headshot,

                training_video_thumbnail: state.options.training.video.thumbnail.id,
                training_video_id: state.options.training.video.id,
                training_download_id: state.options.training.download.id,
                training_download_url: state.options.training.download.url,
                training_description: state.options.training.description,
                load_stock: state.options.loadStock,
                upload_type: state.options.uploadType,
                show_upload_button: state.options.showUploadButton,
                show_select_button: state.options.showSelectButton,
                hero_selector_label: state.options.heroSelector.label,
                hero_selector_choice_one: state.options.heroSelector.choiceOne,
                hero_selector_choice_two: state.options.heroSelector.choiceTwo,
                template_selector_label: state.options.templateSelector.label,
                template_selector_color_one: state.options.templateSelector.colorOne,
                template_selector_color_two: state.options.templateSelector.colorTwo,
                template_selector_color_three: state.options.templateSelector.colorThree,
            },
        };
    },

    entry(state) {
        return state.entry;
    },

    publishedText(state) {
        if (state.published) {
            return 'Published';
        } else {
            return 'Not Published';
        }
    },

    route(state) {
        if (state.fieldId) {
            return '/api/field/edit/' + state.fieldId;
        } else {
            return '/api/field/create';
        }
    }
};

export default getters;
